module.exports = __webpack_public_path__ + "static/media/location-icon.43b35c5d.svg";